/*
 * @Description: 
 * @Author: pcc
 * @Date: 2023-01-11 18:28:17
 * @LastEditors: pcc
 * @LastEditTime: 2023-05-09 11:27:46
 */
import axios from 'axios'
import store from '@/store'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 60000
})

request.interceptors.request.use(
  config => {
    config.headers['TenantId'] = store.state.tenant.tenantInfo.id || ''
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

request.interceptors.response.use(
  response => {
    const { data } = response
    if (data.success) {
      return data
    } else {
      if (data.code === 401) {
        localStorage.removeItem('Token')
        localStorage.removeItem('tenantInfo')
        location.reload()
        location.href = '/home'
      }
      return data
    }
  },
  err => {
    return Promise.reject(err)
  }
)

export default request
